module.exports = __webpack_public_path__ + "img/16.ad9f3ee7.jpg";